import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

export const tooltip: {
  defaultProps?: ComponentsProps['MuiTooltip'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTooltip'];
  variants?: ComponentsVariants<Theme>['MuiTooltip'];
} = {
  defaultProps: {
    // Il n'y a pas de survol au doigt : les 72 infobulles de l'application ne
    // s'ouvrent sur mobile que par appui long. MUI attend 700ms avant de la
    // montrer et la referme après 1,5s — assez pour qu'on croie qu'elle
    // n'existe pas, puis trop peu pour la lire. Ces valeurs n'ont aucun effet
    // au pointeur.
    enterTouchDelay: 300,
    leaveTouchDelay: 4000,
  },
  styleOverrides: {
    tooltip({ theme }) {
      return {
        [theme.breakpoints.down('md')]: {
          fontSize: 12,
          maxWidth: 'calc(100vw - 32px)',
        },
      };
    },
  },
};
